<lib-top-products-summary [items]="data"></lib-top-products-summary>
